<template>
  <div class="pay-page">
    <div class="container">    
      <!-- Main Content -->
      <div class="main-content">
        <!-- Member Benefits -->
        <div class="member-benefits">
          <h3 class="benefits-title">会员专属权益</h3>
          
          <!-- Benefit Category 1 -->
          <div class="benefit-category">
            <h4 class="category-title">听感体验升级</h4>
            <ul class="benefit-list">
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>亿级歌曲免费听</span>
              </li>
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>Hi-Res无损解析</span>
              </li>
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>专属音效任意调</span>
              </li>
            </ul>
          </div>
          
          <!-- Benefit Category 2 -->
          <div class="benefit-category">
            <h4 class="category-title">体验反应权益</h4>
            <ul class="benefit-list">
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>自定义单曲制作</span>
              </li>
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>可多设备同时登录使用</span>
              </li>
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>去除平台弹窗广告</span>
              </li>
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>支持歌曲批量离线下载</span>
              </li>
            </ul>
          </div>
          
          <!-- Benefit Category 3 -->
          <div class="benefit-category">
            <h4 class="category-title">专属福利特权</h4>
            <ul class="benefit-list">
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>每月免费听歌书券</span>
              </li>
              <li class="benefit-item">
                <i class="check-icon"></i>
                <span>尊贵身份标识</span>
              </li>
            </ul>
          </div>
          
          <!-- Crown Icon -->
          <div class="crown-icon">
            <img :src="Images.pay.crown" alt="皇冠图标" class="crown-image">
          </div>
        </div>
        
        <!-- Payment Details -->
        <div class="payment-details">
          <!-- Pricing Plans -->
          <div class="pricing-plans">
            <div 
              v-for="(plan, index) in plans" 
              :key="index"
              class="plan-item"
              :class="{ 'active': selectedPlan === index }"
              @click="selectPlan(index)"
            >
              <div class="plan-duration">{{ plan.duration }}</div>
              <div class="plan-price">¥{{ plan.price }}</div>
              <div class="plan-original-price">¥{{ plan.originalPrice }}</div>
              <div class="plan-daily">{{ plan.daysText }}</div>
            </div>
          </div>
          
          <!-- Plan Info -->
          <div class="plan-info">
            <div class="info-item">
              <span class="info-label">套餐内容：</span>
              <span class="info-value">{{ currentPlan.duration }}会员专属权益</span>
            </div>
            <div class="info-item">
              <span class="info-label">有效期至：</span>
              <span class="info-value">{{ getValidUntilDate() }}</span>
            </div>
            <div class="info-item total-amount">
              <span class="info-label">应付金额：</span>
              <span class="info-value amount">¥{{ formatPrice(currentPlan.price) }}元</span>
            </div>
          </div>  
          
          <!-- Payment Methods -->
          <div class="payment-methods">
            <span class="method-label">支付方式：</span>
            <div class="method-options">
              <button 
                class="method-item"
                :class="{ 'active': selectedPayment === 0 }"
                @click="selectPayment(0)"
              >
                <img :src="Images.pay.wechat" alt="微信支付" class="method-icon">
                <span class="method-name">微信支付</span>
              </button>
              <button 
                class="method-item"
                :class="{ 'active': selectedPayment === 1 }"
                @click="selectPayment(1)"
              >
                <img :src="Images.pay.alipay" alt="支付宝" class="method-icon">
                <span class="method-name">支付宝</span>
              </button>
            </div>
          </div>
          
          <!-- QR Code Payment -->
          <div class="qr-payment">
            <div class="qr-content">
              <div class="qr-code">
                <div v-if="isLoading" class="loading-overlay">
                  <span class="loading-text">加载中...</span>
                </div>
                <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="支付二维码" class="qr-image">
                <img v-else :src="Images.pay.qr_code" alt="支付二维码" class="qr-image">
              </div>
              <div class="qr-info">
                <div class="qr-time">
                  <img :src="Images.pay.alarmClock" alt="倒计时" class="safe-icon">
                  <span>支付剩余时间：{{ paymentTime }}</span>
                </div>
                <div class="qr-safe">
                  <img :src="Images.pay.safety" alt="安全图标" class="safe-icon">
                  <span>已通过安全检测，请使用微信扫码支付</span>
                </div>
                <div class="qr-amount">¥{{ formatPrice(currentPlan.price) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Images } from '@/utils/imageLoader';
import { payApi } from '@/utils/api';

export default {
  name: 'PayView',
  data() {
    return {
      Images,
      selectedPlan: 0, // 当前选中的套餐索引
      selectedPayment: 0, // 当前选中的支付方式索引
      plans: [
        {
          duration: '1个月',
          price: '9.9',
          originalPrice: '19.9',
          days: '30',
          dailyPrice: '0.33',
          daysText: '满至0.33元/天'
        },
        {
          duration: '3个月',
          price: '19.9',
          originalPrice: '39.9',
          days: '90',
          dailyPrice: '0.22',
          daysText: '满至0.22元/天'
        },
        {
          duration: '6个月',
          price: '39.9',
          originalPrice: '79.9',
          days: '180',
          dailyPrice: '0.22',
          daysText: '满至0.22元/天'
        },
        {
          duration: '12个月',
          price: '69.9',
          originalPrice: '159.9',
          days: '365',
          dailyPrice: '0.19',
          daysText: '满至0.19元/天'
        },
        {
          duration: '终身卡',
          price: '99.9',
          originalPrice: '199.9',
          days: '365',
          daysText: '无限时效',
        }
      ],
      paymentSeconds: 900, // 支付剩余时间（秒）
      timer: null, // 定时器引用
      qrCodeUrl: '', // 二维码图片URL
      isLoading: false // 加载状态
    }
  },
  computed: {
    // 计算支付剩余时间的格式化字符串
    paymentTime() {
      const hours = Math.floor(this.paymentSeconds / 3600)
      const minutes = Math.floor((this.paymentSeconds % 3600) / 60)
      const seconds = this.paymentSeconds % 60
      
      // 格式化时间为 HH:MM:SS
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    // 获取当前选中的套餐
    currentPlan() {
      return this.plans[this.selectedPlan]
    }
  },
  methods: {
    // 选择套餐
    selectPlan(index) {
      this.selectedPlan = index
      this.getQRCode() // 重新获取二维码
    },
    // 选择支付方式
    selectPayment(index) {
      this.selectedPayment = index
      this.getQRCode() // 重新获取二维码
    },
    // 格式化价格
    formatPrice(price) {
      return parseFloat(price).toFixed(2)
    },
    // 计算有效期至日期
    getValidUntilDate() {
      const currentPlan = this.currentPlan
      if (currentPlan.duration === '终身卡') {
        return '永久有效'
      }
      
      const today = new Date()
      let monthsToAdd = 0
      
      if (currentPlan.duration.includes('1个月')) {
        monthsToAdd = 1
      } else if (currentPlan.duration.includes('3个月')) {
        monthsToAdd = 3
      } else if (currentPlan.duration.includes('6个月')) {
        monthsToAdd = 6
      } else if (currentPlan.duration.includes('12个月')) {
        monthsToAdd = 12
      }
      
      const validUntil = new Date(today)
      validUntil.setMonth(validUntil.getMonth() + monthsToAdd)
      
      const year = validUntil.getFullYear()
      const month = String(validUntil.getMonth() + 1).padStart(2, '0')
      const day = String(validUntil.getDate()).padStart(2, '0')
      
      return `${year}年${month}月${day}日`
    },
    // 启动支付倒计时
    startPaymentTimer() {
      this.timer = setInterval(() => {
        if (this.paymentSeconds > 0) {
          this.paymentSeconds--
        } else {
          clearInterval(this.timer)
          // 可以在这里添加超时处理逻辑
          alert('支付已超时，请重新发起支付')
        }
      }, 1000)
    },
    // 获取支付二维码
    getQRCode() {
      this.isLoading = true
      
      // 重置支付倒计时
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.paymentSeconds = 900 // 重置为15分钟
      this.startPaymentTimer() // 重新启动倒计时
      
      // 构建请求参数
      let cardPackType = '月卡';
      if (this.currentPlan.duration === '1个月') {
        cardPackType = '月卡';
      } else if (this.currentPlan.duration === '3个月') {
        cardPackType = '季卡';
      } else if (this.currentPlan.duration === '6个月') {
        cardPackType = '半年卡';
      } else if (this.currentPlan.duration === '12个月') {
        cardPackType = '年卡';
      } else if (this.currentPlan.duration === '终身卡') {
        cardPackType = '终身卡';
      }
      
      const params = {
        cardPackType: cardPackType,
        paymentType: this.selectedPayment === 0 ? 'wechat' : 'aliPay'
      }
      
      payApi.getPayQRCode(params)
        .then(data => {
          // 假设返回的data是微信支付的scheme链接，需要转换为二维码图片
          // 使用在线二维码生成服务将链接转换为二维码图片
          this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(data)}`
          this.isLoading = false
        })
        .catch(error => {
          console.error('获取二维码失败:', error)
          alert('获取二维码失败: ' + (error.msg || '请稍后重试'))
          this.isLoading = false
        })
    }
  },
  mounted() {
    // 页面加载完成后启动倒计时
    this.startPaymentTimer()
    // 页面加载完成后获取二维码
    this.getQRCode()
  },
  beforeUnmount() {
    // 页面销毁前清除计时器
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
/* Global Styles */
.pay-page {
  background-color: #f8f8f8;  
  min-height: 100vh;
  padding-top: 200px;
}

/* 顶部会员页画 */
.member-banner {
  background-color: #f0f0f0;
  color: #666;
  font-size: 14px;
  padding: 10px 0;
  text-align: left;
  padding-left: 20px;
}

.container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 50px;
}

/* Page Header */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px 0;
  background-color: white;
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.member-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.member-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.member-name {
  font-size: 14px;
  color: #666;
}

/* Main Content */
.main-content {
  display: flex;
  gap: 30px;
  background-color: white;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  min-height: 800px;
}

/* Member Benefits */
.member-benefits {
  width: 280px;
  background: linear-gradient(to bottom,#fdf6e7, #f9e9c2);
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #ffecd1;
}

.benefits-title {
  font-size: 20px;
  font-weight: bold;
  color: #544120;
  margin: 0 0 20px 0;
  text-align: center;
}

.benefit-category {
  margin-bottom: 20px;
}

.category-title {
  font-size: 16px;
  font-weight: 600;
  color: #544120;
  margin: 0 0 10px 0;
}

.benefit-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #544120;
  margin-bottom: 10px;
}

.check-icon {
  width: 12px;
  height: 12px;
  background-color: #ff6b00;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  flex-shrink: 0;
}

.check-icon::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 8px;
  font-weight: bold;
}

/* Crown Icon */
.crown-icon {
  text-align: center;
  margin-top: 120px;
  margin-right: 20px;
}

.crown-image {
  width: 100px;
  height: auto;
  opacity: 0.8;
}

/* Payment Details */
.payment-details {
  flex: 1;
}

/* Pricing Plans */
.pricing-plans {
  display: flex;
  gap: 16px;
  margin-bottom: 30px;
  align-items: stretch;
}

.plan-item {
  min-width: 160px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.plan-item.active {
  border-color: #ff6b00;
  box-shadow: 0 2px 8px rgba(255, 107, 0, 0.1);
  background-color: #fff9f5;
}

.plan-item.more {
  opacity: 0.6;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.plan-duration {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.plan-item.active .plan-duration {
  color: #ff6b00;
}

.plan-price {
  font-size: 24px;
  font-weight: bold;
  color: #ff6b00;
  margin-bottom: 6px;
  line-height: 1;
}

.plan-original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
  margin-bottom: 6px;
}

.plan-item.active .plan-price {
  color: #ff6b00;
}

.plan-daily {
  font-size: 12px;
  color: white;
  background-color: #ff6b00;
  padding: 6px 8px;
  border-radius: 12px;
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 0px;
  font-weight: 500;
  align-self: center;
}

.plan-item:not(.active) .plan-daily {
  background-color: #f0f0f0;
  color: #999;
}

.plan-arrow {
  font-size: 24px;
  color: #999;
  margin-top: 10px;
}

/* Plan Info */
.plan-info {
  margin-bottom: 30px;
  padding: 0;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  color: #666;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  font-weight: 500;
  color: #212121;
}

.info-value {
  text-align: right;
  color: #212121;
}

.info-item.total-amount {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.info-item.total-amount .amount {
  font-size: 30px;
  font-weight: bold;
  color: #ff6b00;
}

/* Payment Methods */
.payment-methods {
  margin-bottom: 30px;
}

.method-label {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
  display: block;
}

.method-options {
  display: flex;
  gap: 16px;
}

.method-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: white;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
  color: #333;
  width: 150px;
  text-align: center;
}

.method-item.active {
  border: 1px solid #ff6b00;
  background-color: white;
}

.method-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* QR Code Payment */
.qr-payment {
  background-color: #f8f8f8;
  border-radius: 8px;
}

.qr-content {
  display: flex;
  gap: 30px;
  align-items: center;
  background-color: #F6F6F6;
  border-radius: 8px;
  padding: 30px;
}

.qr-code {
  width: 180px;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.qr-image {
  width: 160px;
  height: 160px;
  object-fit: contain;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  z-index: 10;
}

.loading-text {
  font-size: 16px;
  color: #ff6b00;
  font-weight: 500;
}

.qr-code {
  position: relative;
}

.qr-info {
  flex: 1;
}

.qr-time, .qr-safe {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}

.qr-time {
  color: #ff6b00;
}

.time-icon {
  width: 14px;
  height: 14px;
  display: inline-block;
  background-color: #ff6b00;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
}

.safe-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}

.time-icon::after, .safe-icon::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 8px;
  font-weight: bold;
}

.qr-amount {
  font-size: 28px;
  font-weight: bold;
  color: #ff6b00;
  margin-top: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }
  
  .member-benefits {
    width: 100%;
  }
  
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .pricing-plans {
    overflow-x: auto;
  }
  
  .qr-content {
    flex-direction: column;
    text-align: center;
  }
}
</style>